import { useContext, useState, useEffect } from 'react';
import ForwardRefContext from 'src/contexts/ForwardRefContext';
import AudioContext from 'src/contexts/AudioContext';
import { useVisible, useBreakpoint } from 'src/hooks';

export const useInputBoxState = () => {
  const { threadInputBoxRef } = useContext(ForwardRefContext);
  const { recordInProgress } = useContext(AudioContext);
  const { isDesktopAndUp } = useBreakpoint();
  const {
    isVisible: isVisibleContactPicker,
    onVisibilitySet: onOpenContactPicker,
    onVisibilityRemove: onCloseContactPicker,
  } = useVisible();

  const {
    isVisible: isVisibleCommandPicker,
    onVisibilitySet: onOpenCommandPicker,
    onVisibilityRemove: onCloseCommandPicker,
  } = useVisible();

  const [shouldNotSubmitOnEnter, setNotSubmitOnEnter] =
    useState<boolean>(false);

  // disable submit while QuickPicker is opened
  useEffect(() => {
    setNotSubmitOnEnter(isVisibleContactPicker || isVisibleCommandPicker);
  }, [isVisibleContactPicker, isVisibleCommandPicker]);

  // auto-scrolling content to the bottom within the input box while text-to-speech
  useEffect(() => {
    if (threadInputBoxRef?.current && recordInProgress) {
      threadInputBoxRef.current.scrollTop =
        threadInputBoxRef?.current.scrollHeight;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threadInputBoxRef?.current?.scrollHeight, recordInProgress]);

  useEffect(() => {
    if (isDesktopAndUp) {
      threadInputBoxRef?.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [threadInputBoxRef, isDesktopAndUp]);

  return {
    shouldNotSubmitOnEnter,
    isVisibleContactPicker,
    isVisibleCommandPicker,
    onOpenContactPicker,
    onCloseContactPicker,
    onOpenCommandPicker,
    onCloseCommandPicker,
  };
};
